<template>
  <div class="home">
    <h2>Welcome to a BookListExplorer Kata</h2>
    <p>
      You can explore a list of books and getting detailed information by
      clicking on the isbn links
    </p>
    <p>
      To start your journey, just click on the booklink in the top navgation
    </p>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
};
</script>
